<div class="card">
  <div class="card-body">
    <div class="row">
      <div class="col-12 mb-3 d-flex flex-wrap align-items-center justify-content-between gap-2">
        <h4 class="mb-0">{{ 'pages.transport.detail-page.bulk.headline' | translate }}</h4>
        <p-iconfield>
          <p-inputicon class="pi pi-search" />
          <input
            id="bulkSearch"
            pInputText
            type="text"
            [placeholder]="'general.search' | translate"
            [value]="searchTerm()"
            (input)="searchTerm.set($any($event.target).value)"
          />
          <label for="bulkSearch" class="d-none sr-only">{{ 'general.search' | translate }}</label>
        </p-iconfield>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <p-treeTable [value]="bulkHandlingUnits()" [columns]="cols" [autoLayout]="true" [tableStyle]="{ 'min-width': 'max-content' }">
          <ng-template pTemplate="header" let-columns>
            <tr>
              @for (col of columns; track $index) {
                <th scope="col" [style]="col.style">{{ col.header }}</th>
              }
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowNode let-rowData="rowData">
            <tr [ttRow]="rowNode">
              @for (col of cols; track col.field; let first = $first) {
                <td [style]="col.style">
                  @if (first) {
                    <p-treeTableToggler [rowNode]="rowNode" />
                  }
                  <span>
                    @for (segment of rowData[col.field] | highlight: searchTerm(); track $index) {
                      @if (segment.matched) {
                        <mark>{{ segment.text }}</mark>
                      } @else {
                        <ng-container>{{ segment.text }}</ng-container>
                      }
                    }
                  </span>
                </td>
              }
            </tr>
          </ng-template>
        </p-treeTable>
      </div>
    </div>
  </div>
</div>
